import React from 'react'
import Donate from './Donate'

function Banner() {

  return (
    <div className='homebanner' >
      <div className='homebanner_overlay'>
        <div className='homebanner_container homebann'>
          <div className='homebanner_text' >
              <h1>THE LORD Nations FOUNDATION</h1>
              <p>Lending a Hand, Changing Lives</p>
          </div>

          <div className='danate_desk'>
            <Donate/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Banner